import { QUERY } from '@skooldio/classroom-frontend-api';

const {
  getMyUserIconInfo,
  getAuthFormInfo,
  getProfileFormInfo,
  getCompanyFormInfo,
  getMenuBarInfo,
  getProfilePic,
  getProfile,
  getMyExternalProfileInfo,
} = QUERY.MyProfile;

export {
  getMyUserIconInfo,
  getAuthFormInfo,
  getProfileFormInfo,
  getCompanyFormInfo,
  getMenuBarInfo,
  getProfilePic,
  getProfile,
  getMyExternalProfileInfo,
};
